import React from 'react';
import { Tag } from 'src/@vymo/ui/atoms';
import { CASE, STATE_ID } from '../../constant';

export const getCasesColumns = (revyreConfig) => {
  const columns = revyreConfig[CASE]?.columnConfigs || [];
  return columns
    .filter(({ visible }) => (visible?.enabledFor || []).includes('web'))
    .map((column) =>
      column.code === STATE_ID
        ? {
            ...column,
            cell: (value: string) => {
              const states = revyreConfig?.[CASE]?.states || [];

              const correspondingState = states.find(
                (event) => event?.id === value,
              );

              return <Tag label={correspondingState?.name} />;
            },
          }
        : column,
    );
};
